module.exports = __webpack_public_path__ + "static/media/airplane-unsplash.49819b21.jpg";